"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const So = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 81 54", ...props },
    react_1.default.createElement("path", { fill: "#4189DD", d: "M0 0h81v54H0z" }),
    react_1.default.createElement("g", { transform: "matrix(13 0 0 13 40.5 27)" },
        react_1.default.createElement("g", { id: "so_svg__b" },
            react_1.default.createElement("path", { id: "so_svg__a", fill: "#FFF", d: "M0 0v1h.5z", transform: "rotate(18 3.157 -.5)" }),
            react_1.default.createElement("use", { xlinkHref: "#so_svg__a", transform: "scale(-1 1)" })),
        react_1.default.createElement("use", { xlinkHref: "#so_svg__b", transform: "rotate(72)" }),
        react_1.default.createElement("use", { xlinkHref: "#so_svg__b", transform: "rotate(-72)" }),
        react_1.default.createElement("use", { xlinkHref: "#so_svg__b", transform: "rotate(144)" }),
        react_1.default.createElement("use", { xlinkHref: "#so_svg__b", transform: "rotate(-144)" }))));
exports.default = So;
//# sourceMappingURL=So.js.map